var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{attrs:{"id":"loginModal","show":_vm.show,"center":""}},[_c('LogInPaper',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.onClose),expression:"onClose"}],ref:"loginPaper",staticClass:"login-module-root extend-bottom-mobile",attrs:{"id":"loginPaper"},on:{"close":_vm.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }